<div class="wrapper" #wrapper>
    <button class="plusminus" (click)="handleMinus()">-</button>
    <input type="number" class="num" [value]="val"
      (change)="onInputChange($event)" (keyup)="checkNan($event)" />
    <button class="plusminus" (click)="handlePlus()">+</button>
  </div>